<template>
  <div class="content">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <div v-loading="loading">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="row">
                    <div class="col-md-6 text-muted">
                      Page {{ topicsPagination.page }} / {{ topicsPagination.pages }}
                      - {{ topicsPagination.total }} élément(s)
                    </div>
                    <div class="col-md-6 text-right">
                      <a href @click.prevent="createTopic()" class="btn btn-default">
                        <i class="fa fa-plus"></i>
                        Créer un dossier
                      </a>
                    </div>
                  </div>
                </div>
                <div class="card-body table-responsive">
                  <table class="table table-hover">
                    <tbody>
                      <tr
                        v-for="topic in topics"
                        :key="topic.id"
                        class="pointer"
                        @click="toTopic(topic.id)"
                      >
                        <td>
                          <el-image
                            style="width: 70px; height: 70px"
                            :src="topic.thumb_topic_list_url"
                            fit="contain"
                          ></el-image>
                        </td>
                        <td>
                          <h5 class="m-b-10" :class="{'text-muted': !topic.title}">
                            <span v-if="topic.rich_title" v-html="topic.rich_title"></span>
                            <span v-else>{{ topic.title || 'Aucun titre' }}</span>
                            <br />
                            <small>
                              <i class="fa fa-folder-o" />
                              <span
                                :class="{'badge-success': topic.status == 'PUBLISHED', 'badge-danger': topic.status == 'DISABLED'}"
                                class="badge m-l-5 m-r-5"
                              >{{ topic.status | translate }}</span>
                              créé {{ topic.created_at | fromNowDate }}
                              - publié le {{ topic.published_at | formatDate('DD/MM/YYYY à HH:mm') }}
                            </small>
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <hr class="m-t-10" />
                  <div class="text-center">
                    <el-pagination
                      @size-change="setPage"
                      @current-change="setPage"
                      :page-size="topicsPagination.per_page"
                      :pager-count="5"
                      :page-count="topicsPagination.pages"
                      :page-sizes="[8, 16, 24, 50, 100]"
                      :current-page="topicsPagination.page"
                      layout="total, prev, pager, next"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      topics: "topics",
      topicsPagination: "topicsPagination",
      topic: "topic"
    })
  },
  data() {
    return {
      loading: false,
      default_filters: null,
      filters: {
        display: false,
        page: 1
      },
      mask:
        "id, thumb_topic_list_url, title, rich_title, status, created_at, published_at"
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      if (this.default_filters === null) {
        this.default_filters = Object.assign({}, this.filters);
      }
      this.filters = Object.assign(this.filters, this.$route.query);
      this.$store
        .dispatch("getTopics", {
          params: this.filters,
          headers: { "x-fields": this.mask }
        })
        .then(() => {
          this.loading = false;
        });
    },
    createTopic() {
      this.$store.dispatch("createTopic", {}).then(() => {
        this.$router.replace({
          name: "topic",
          params: { id: this.topic.id }
        });
      });
    },
    toTopic(topicId, edit) {
      this.$router.push({
        name: "topic",
        params: { id: topicId },
        query: { edit: edit }
      });
    },
    setPage(page) {
      if (this.filters.display === false && this.default_filters) {
        this.filters = Object.assign({}, this.default_filters);
      }
      this.filters.page = page;
      this.$router.replace({
        name: "topics",
        query: Object.assign({}, this.filters)
      });
      window.scrollTo(0, 0);
    }
  }
};
</script>